import { EntityService } from '../../service/EntityService';

export class InvoiceService extends EntityService {

  static entity = 'app/invoice';

  static getListInvoiceSign(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/invoice-sign`, { params }).then(res => res.data);
  }

  static getPaymentTypes(): Promise<any> {
    return this.axios.get(`app/payment-type`, { params: { maxResultCount: 1000, Sorting: 'code', SortType: 'ASC' } }).then(res => res.data);
  }

  static deleteBatch(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/mutile-delete`, data).then(res => res.data);
  }

  static downloadInvoiceExcel(registerInvoiceId: string): Promise<any> {
    return this.axios.get(`${this.entity}/file-excel/${registerInvoiceId}`, { responseType: 'blob' }).then(res => res.data);
  }

  static uploadInvoiceExcel(registerInvoiceId: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload/${registerInvoiceId}`, data).then(res => res.data);
  }

  static downloadInvoicePdf(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/downloaf-pdf`, { responseType: 'blob' }).then(res => res.data);
  }

  static printViewDraft(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/print-view-draft-html`, data).then(res => res.data);
  }

  static downloadInvoiceXml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/download-xml/${id}`, { responseType: 'blob' }).then(res => res.data);
  }

  static printViewHtml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/print-view-html`).then(res => res.data);
  }

  static printMultiHtml(data: any): Promise<any> {
    // return this.axios.post(`${this.entity}/${id}/print-view-html`).then(res => res.data);
    return this.axios.post(`${this.entity}/print-multi-html`, data).then(res => res.data);
  }

  static printViewSwitchHtml(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/print-view-swich-html`).then(res => res.data);
  }

  static getParentInvoice(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/parent-invoice`).then(res => res.data);
  }

  static getListSubstitutes(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/invoices-substitute`, { params }).then(res => res.data);
  }

  static getSubstitute(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/substitute-invoice`).then(res => res.data);
  }

  static createSubstitute(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/substitute`, data).then(res => res.data);
  }

  static updateSubstitute(id: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/substitute`, data).then(res => res.data);
  }

  static getListAdjustments(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/invoices-adjustment`, { params }).then(res => res.data);
  }

  static getAdjustment(id: string): Promise<any> {
    return this.axios.get(`${this.entity}/${id}/adjustment-invoice`).then(res => res.data);
  }

  static createAdjustment(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/adjustment`, data).then(res => res.data);
  }

  static updateAdjustment(id: string, data: any): Promise<any> {
    return this.axios.put(`${this.entity}/${id}/adjustment`, data).then(res => res.data);
  }

  static getListCancels(params: any): Promise<any> {
    return this.axios.get(`${this.entity}/invoices-cancel`, { params }).then(res => res.data);
  }

  static downloadExcelDetail(registerInvoiceId: string): Promise<any> {
    return this.axios.get(`${this.entity}/file-excel-detail/${registerInvoiceId}`, { responseType: 'blob' }).then(res => res.data);
  }

  static uploadExcelDetail(registerInvoiceId: string, data: any): Promise<any> {
    return this.axios.post(`${this.entity}/upload-detail/${registerInvoiceId}`, data).then(res => res.data);
  }

  static createSyncInvoice(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/sync-invoice`, data).then(res => res.data);
  }

  static createChangeSerial(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/change-serial`, data).then(res => res.data);
  }

  static getTaxAuthStatus(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/status-on-tax-authority`, data).then(res => res.data);
  }

  static setTaxAuthStatus(data: any): Promise<any> {
    return this.axios.put(`${this.entity}/status-on-tax-authority`, data).then(res => res.data);
  }
  static updateBatchCompany(data: any): Promise<any> {
    return this.axios.post(`${this.entity}/replace-company-info`, data).then(res => res.data);
  }

  static documentType_Cancel = 1;
  static documentType_Adjust = 2;
  static documentType_Substitute = 3;
  static sendTaxStatuses = [
    { value: 0, label: 'Chờ duyệt' },
    { value: 1, label: 'Chờ ký' },
    { value: 2, label: 'Đã ký' },
    { value: 3, label: 'Đang gửi' },
    { value: 4, label: 'Thành công' },
    { value: 5, label: 'Có lỗi' },
    { value: 6, label: 'Từ chối' }
  ];

  static invoiceStatuses = [
    { value: 0, label: 'Gốc' },
    { value: 1, label: 'Hủy' },
    { value: 2, label: 'Điều chỉnh' },
    { value: 3, label: 'Thay thế' },
    { value: 4, label: 'Giải trình' },
    { value: 5, label: 'Bị điều chỉnh' },
    { value: 6, label: 'Bị thay thế' }
  ];

  static itemProperties = [
    { value: 1, label: 'Hàng hóa dịch vụ', multiplier: 1 },
    { value: 2, label: 'Khuyến mại', multiplier: -1 },
    { value: 3, label: 'Chiết khấu thương mại', multiplier: 0 },
    { value: 4, label: 'Ghi chú diễn giải', multiplier: 0 },
    { value: 5, label: 'Hàng hóa đặc trưng', multiplier: 1 }
  ];

}
